<div (appOutsideClick)="clickOutside($event)">

  <!-- ========== MOBILE HEADER ========== -->
  <div class="block md:hidden w-full bg-vivid-royal-600 sticky top-0 z-50 shadow-md">
    <div class="flex items-center justify-between px-4 py-3">
      <img (click)="goTo('app/dashboard',-1,false,false)" src="./assets/logos/energo_logo_dark.svg" class="h-8 cursor-pointer" />
      <div class="flex items-center gap-3">
        <button (click)="showNotications=true" class="text-white/70 hover:text-white transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>
        </button>
        <button (click)="changeMode()" class="text-white/70 hover:text-white transition-colors">
          <img [src]="getIconThemeMode()" class="w-5 h-5" />
        </button>
        <button (click)="openMenu=!openMenu" class="text-white/70 hover:text-white transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            @if(!openMenu) {
              <line x1="3" x2="21" y1="6" y2="6"/><line x1="3" x2="21" y1="12" y2="12"/><line x1="3" x2="21" y1="18" y2="18"/>
            } @else {
              <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
            }
          </svg>
        </button>
      </div>
    </div>

    @if(openMenu) {
      <nav class="bg-vivid-royal-600 border-t border-white/10 px-3 pb-4 max-h-[70vh] overflow-y-auto">
        @for(item of menuOptionsMob | slice:0:8; track item; let idx=$index) {
          @if(item.visible) {
            <a (click)="item.route != '' ? goTo(item.route,idx,true) : showSubMenu(idx)" class="flex items-center gap-3 px-4 py-3 mt-1 rounded-xl text-sm text-white/90 hover:bg-white/10 transition-all cursor-pointer"
              [ngClass]="{'bg-white/10':subMenuExpanded==idx}"  
            >
              @if(idx == menuOptions.length - 1) {
                <app-avatar [name]="profileData?.name || ''" size="sm" />
              } @else {
                <img src="./assets/icons/{{item.icon}}" class="w-5 h-5" />
              }
              <span class="flex-1 font-medium">{{item.label}}</span>
              @if(item.subMenu.length > 0) {
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-white/40 transition-transform duration-200" [class.rotate-90]="subMenuExpanded == idx" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg>
              }
            </a>
            @if(subMenuExpanded == idx && item.subMenu.length > 0) {
              <div class="ml-9 border-l-2 border-mustard-500/30 pl-3 mb-1">
                @for(sub of item.subMenu; track sub) {
                  @if(sub.visible) {
                    <a (click)="goTo(sub.route,idx);openMenu=false"
                      class="block px-3 py-2 text-sm text-white/70 hover:text-mustard-400 rounded-lg transition-colors cursor-pointer">
                      {{sub.label}}
                    </a>
                  }
                }
              </div>
            }
          }
        }
      </nav>
    }
  </div>

  <!-- ========== DESKTOP SIDEBAR ========== -->
  <div #sidebar
    class="hidden md:flex flex-col h-screen bg-gradient-to-b from-vivid-royal-700 to-vivid-royal-800 z-40 transition-all duration-300 ease-in-out shadow-lg"
    [ngClass]="collapse ? 'w-[72px]' : 'w-[260px]'">

    <!-- Logo -->
    <div class="flex items-center pt-6 pb-5" [ngClass]="collapse ? 'justify-center px-3' : 'px-6'">
      <img (click)="goTo('app/dashboard',-1,true,false)" src="./assets/logos/energo_logo_dark.svg"
        [ngClass]="collapse ? 'h-7' : 'h-9'" class="cursor-pointer transition-all" />
    </div>

    <div class="mx-4 border-t border-white/10"></div>

    <!-- Navigation -->
    <nav class="flex-1 overflow-y-auto overflow-x-hidden px-3 py-4 space-y-1">
      @for(item of menuOptions | slice:0:6; track item; let idx=$index) {
        @if(item.visible) {
          <div (click)="item.route != '' ? goTo(item.route,idx) : showSubMenu(idx)"
            class="group flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-200"
            [ngClass]="{
              'bg-white/15 text-white shadow-sm': subMenuExpanded == idx,
              'text-white/75 hover:bg-white/10 hover:text-white': subMenuExpanded != idx,
              'px-4 pt-3 pb-3': !collapse,
              'justify-center py-3.5 px-0': collapse
            }">
            <img src="./assets/icons/{{item.icon}}" class="w-5 h-5 flex-shrink-0 transition-transform duration-200 group-hover:scale-110" />
            @if(!collapse) {
              <span class="text-[13px] font-medium flex-1 truncate">{{item.label}}</span>
              @if(item.subMenu.length > 0) {
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-white/30 transition-transform duration-200" [class.rotate-90]="subMenuExpanded == idx" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg>
              }
            }
          </div>

          <!-- Submenu inline -->
          @if(!collapse && subMenuExpanded == idx && item.subMenu.length > 0) {
            <div class="ml-7 border-l-2 border-mustard-500/30 pl-3 py-1 space-y-0.5">
              @for(sub of item.subMenu; track sub) {
                @if(sub.visible) {
                  <a (click)="goTo(sub.route,idx)"
                    class="block px-3 py-1.5 text-[13px] text-white/60 hover:text-mustard-400 rounded-lg transition-colors cursor-pointer truncate">
                    {{sub.label}}
                  </a>
                }
              }
            </div>
          }

          <!-- Collapsed popover -->
          @if(collapse && subMenuExpanded == idx && item.subMenu.length > 0) {
            <div class="fixed ml-[72px] -mt-10 bg-vivid-royal-700 border border-white/10 rounded-xl shadow-2xl py-2.5 px-1.5 min-w-[200px] z-50">
              <div class="px-3 py-1 text-xs font-semibold text-mustard-500 uppercase tracking-wider">{{item.label}}</div>
              @for(sub of item.subMenu; track sub) {
                @if(sub.visible) {
                  <a (click)="goTo(sub.route,idx)"
                    class="block px-3 py-1.5 text-sm text-white/80 hover:text-mustard-400 hover:bg-white/10 rounded-lg transition-colors cursor-pointer">
                    {{sub.label}}
                  </a>
                }
              }
            </div>
          }
        }
      }
    </nav>

    <!-- Bottom section -->
    <div class="px-3 pb-4 space-y-1">
      <div class="mx-2 border-t border-white/10 mb-3"></div>

      <!-- Theme toggle -->
      <div class="flex items-center rounded-xl cursor-pointer transition-all duration-200 text-white/70 hover:bg-white/10 hover:text-white"
        [ngClass]="collapse ? 'justify-center py-3.5' : 'gap-3 px-4 py-3.5'"
        (click)="changeMode()">
        <img [src]="getIconThemeMode()" class="w-5 h-5 flex-shrink-0" />
        @if(!collapse) {
          <span class="text-[13px] font-medium">{{darkModeEnabled ? 'Modo claro' : 'Modo oscuro'}}</span>
        }
      </div>

      <!-- Help -->
      @if(this.data.UserType != 'Finance') {
        <div (click)="showSubMenu(menuOptions.length - 2)"
          class="group flex items-center rounded-xl cursor-pointer transition-all duration-200"
          [ngClass]="{
            'bg-white/15 text-white': subMenuExpanded == menuOptions.length - 2,
            'text-white/70 hover:bg-white/10 hover:text-white': subMenuExpanded != menuOptions.length - 2,
            'gap-3 px-4 pt-3 pb-3': !collapse,
            'justify-center ': collapse
          }">
          <img src="./assets/icons/ayuda.png" class="w-5 h-5 flex-shrink-0 group-hover:scale-110 transition-transform" />
          @if(!collapse) {
            <span class="text-[13px] font-medium flex-1">Ayuda</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-white/30 transition-transform duration-200" [class.rotate-90]="subMenuExpanded == menuOptions.length - 2" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg>
          }
        </div>
        @if(!collapse && subMenuExpanded == menuOptions.length - 2) {
          <div class="ml-7 border-l-2 border-mustard-500/30 pl-3 py-1 space-y-0.5">
            @for(sub of menuOptions[menuOptions.length-2].subMenu; track sub; let i=$index) {
              <a (click)="goTo(sub.route, menuOptions.length - 2)"
                class="block px-3 py-2 text-[13px] text-white/60 hover:text-mustard-400 rounded-lg transition-colors cursor-pointer">
                {{sub.label}}
              </a>
            }
          </div>
        }
        @if(collapse && subMenuExpanded == menuOptions.length - 2) {
          <div class="fixed ml-[72px] bottom-32 bg-vivid-royal-700 border border-white/10 rounded-xl shadow-2xl py-2.5 px-1.5 min-w-[200px] z-50">
            <div class="px-3 py-3 text-xs font-semibold text-mustard-500 uppercase tracking-wider">Ayuda</div>
            @for(sub of menuOptions[menuOptions.length-2].subMenu; track sub) {
              <a (click)="goTo(sub.route, menuOptions.length - 2)"
                class="block px-3 py-2 text-sm text-white/80 hover:text-mustard-400 hover:bg-white/10 rounded-lg transition-colors cursor-pointer">
                {{sub.label}}
              </a>
            }
          </div>
        }
      }

      <!-- Profile -->
      <div (click)="showSubMenu(menuOptions.length - 1)"
        class="group flex items-center rounded-xl cursor-pointer transition-all duration-200"
        [ngClass]="{
          'bg-white/15 text-white': subMenuExpanded == menuOptions.length - 1,
          'text-white/70 hover:bg-white/10 hover:text-white': subMenuExpanded != menuOptions.length - 1,
          'gap-3 px-4 pt-3 pb-3': !collapse,
          'justify-center py-3': collapse
        }">
        <app-avatar [name]="profileData?.name || ''" size="md" />
        @if(!collapse) {
          <div class="flex-1 min-w-0">
            <div class="text-[13px] font-medium truncate text-white/90">{{profileData?.name || ''}}</div>
            <div class="text-xs text-white/40 truncate">{{profileData?.userType || ''}}</div>
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-white/30 transition-transform duration-200" [class.rotate-90]="subMenuExpanded == menuOptions.length - 1" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg>
        }
      </div>
      @if(!collapse && subMenuExpanded == menuOptions.length - 1) {
        <div class="ml-7 border-l-2 border-mustard-500/30 pl-3 py-1 space-y-0.5">
          @for(sub of menuOptions[menuOptions.length-1].subMenu; track sub) {
            @if(sub.visible) {
              <a (click)="goTo(sub.route, menuOptions.length - 1)"
                class="block px-3 pt-2 pb-2 text-[13px] text-white/60 hover:text-mustard-400 rounded-lg transition-colors cursor-pointer">
                {{sub.label}}
              </a>
            }
          }
        </div>
      }
      @if(collapse && subMenuExpanded == menuOptions.length - 1) {
        <div class="fixed ml-[72px] bottom-16 bg-vivid-royal-700 border border-white/10 rounded-xl shadow-2xl py-2.5 px-1.5 min-w-[200px] z-50">
          <div class="px-3 py-1 text-xs font-semibold text-mustard-500 uppercase tracking-wider">Perfil</div>
          @for(sub of menuOptions[menuOptions.length-1].subMenu; track sub) {
            @if(sub.visible) {
              <a (click)="goTo(sub.route, menuOptions.length - 1)"
                class="block px-3 pt-2 pb-2 text-sm text-white/80 hover:text-mustard-400 hover:bg-white/10 rounded-lg transition-colors cursor-pointer">
                {{sub.label}}
              </a>
            }
          }
        </div>
      }

      <!-- Collapse toggle -->
      <button (click)="collapse=!collapse"
        class="w-full flex items-center rounded-xl py-3 text-white/40 hover:text-mustard-400 hover:bg-white/10 transition-all duration-200 cursor-pointer"
        [ngClass]="collapse ? 'justify-center' : 'gap-3 px-4'">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 transition-transform duration-300" [class.rotate-180]="collapse" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect width="18" height="18" x="3" y="3" rx="2"/><path d="M9 3v18"/><path d="m14 9 3 3-3 3"/>
        </svg>
        @if(!collapse) {
          <span class="text-[13px] font-medium">Colapsar</span>
        }
      </button>
    </div>
  </div>
</div>

@if(showNotications) {
  <app-notification-center (onClose)="showNotications=false"></app-notification-center>
}
